export class MerchantPercent {
  merchantArcaPercent: number;
  merchantLocalPercent: number;
  merchantOutPercent: number;
}
